<script>
import { mapActions, mapState } from "vuex";

import Modal from "@/components/_Shared/Modal/Index";
import Title from "@/components/_Shared/Title";

import Address from "../../../../PurchaseFlow/Components/Scheduler/Steps/Address/Address";
import Addresses from "../../../../PurchaseFlow/Components/Scheduler/Steps/Address/Addresses";

export default {
  components: {
    Modal,
    Title,
    Address,
    Addresses
  },

  props: {
    address: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      otherAddresses: false
    };
  },

  computed: {
    ...mapState("addresses", ["addresses"])
  }
};
</script>

<template>
  <Modal v-if="!otherAddresses">
    <template slot="header">
      <Title title="Selecione o local da limpeza para continuar" />
    </template>

    <template slot="body">
      <Address :address="address" @addressSelected="$emit('onAddressSelection')" />

      <p class="text">ou</p>

      <div class="other" @click="otherAddresses = true">
        Outro endereço
      </div>
    </template>

    <template slot="footer">
      <button class="btn bg-outlined" @click="$emit('onReturn')">
        <span>Voltar</span>
      </button>
    </template>
  </Modal>

  <Addresses
    v-else
    @addressSelection="$emit('onAddressSelection')"
  />
</template>

<style scoped>
.text {
  text-align: center;
  font-weight: 500;
  width: calc(100% - 24px - 24px);
  padding: 12px;
  margin: 4px auto 0;
}

.other {
  width: calc(100% - 24px - 24px);
  padding: 12px;
  margin: 4px auto 0;
  border: solid 1px #e2e2e2;
  text-align: center;
  font-weight: 400;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Order/Components/Actions/Professional/Address.vue